import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as timelineEventsActions from 'redux/modules/timelineEvents';
import { Button } from 'react-bootstrap';

var moment = require('moment');
require('moment/locale/fr');

import { translate } from 'react-i18next';

@translate(['common'])

@connect(
  state => ({
    loading: state.timelineEvents.csv_loading,
    user: state.auth.user,
    csvString: state.timelineEvents.csvString
  }),
  dispatch => bindActionCreators({ ...timelineEventsActions }, dispatch)
)

export default class ExportCSVFormTimeEvents extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };

    this.exportCSV = this.exportCSV.bind(this);

    this.generateCSV = this.generateCSV.bind(this);

    

  }


  exportCSV() {

    //Regarder combien de lots de 1000 ont été chargé

    const {chunkIndex, count, rows} = this.props

    const totalChunks = Math.ceil(count/1000)

    const remainingChunks = (totalChunks-1) - chunkIndex

    var allRows = []

    if( remainingChunks > 0 ) {

      var promises = []

      for(var i=chunkIndex+1; i < totalChunks; i++  ) {
        promises.push(this.props.load(this.props.params, null, null, false, i))
      }
      
      Promise.all(promises).then(values=>{
        allRows = rows.concat(values.map(r=>r.rows).flat())
        this.generateCSV(allRows, totalChunks-1)
    })


    } else {

      allRows = rows

      this.generateCSV(allRows, totalChunks-1)
    }
    

    
   

  }


  generateCSV(allRows, chunkIndex){

     this.props.exportCSV(this.props.urlParams, allRows).then((csv) => {

      var filename = "export_timeline_events_" + moment().format('DD-MM-YYYY HH:mm') + '.csv';
      csv = csv.replace(/null/gi, '').replace(/%%%%/g, ';').replace(/indispo_infos/, 'indispo_infos ([Date début | Date fin | Raison], [..], n*)').replace(/;0;/g, ';Non;').replace(/;1;/g, ';Oui;')
      var blob = new Blob([csv], { type: 'text/csv' });

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      }

      else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }

      this.setState({loading:false})

      this.props.changeChunkIndex(chunkIndex, false)




      })
  }


  render() {

    const {
      user,
    } = this.props;


    var style = { display: this.state.disableDate ? 'none' : 'block' }

    var self = this;

    return ( 

      <div>
        <Button bsStyle="warning" type="button" onClick={() => { this.setState({loading:true}, ()=>self.exportCSV())  }}>Export CSV</Button> &nbsp;

        {this.state.loading &&
          <i style={{fontSize:'22px'}} className={'fa fa-spinner fa-spin'}/>
        }
      </div>


    );
  }
}

